import { map, Observable } from 'rxjs';
import { ajax } from 'rxjs/ajax';

import { createDebug } from './runtimeDebug';
const debug = createDebug('ajax.ts');

export function getJSON<T>(url, headers = {}): Observable<T> {
    debug('GET', url, headers);
    const outgoingOptions = {
        url,
        method: 'GET' as const,
        responseType: 'json' as const,
        crossDomain: true,
        headers: {
            ...headers,
        },
    };

    return ajax(outgoingOptions).pipe(map((r) => r.response as T));
}

export function baseAjax(method: 'POST' | 'PUT' | 'DELETE') {
    return function (url, body?, headers = {}) {
        debug(method, url, body, headers);
        return ajax({
            url,
            body,
            method,
            headers: {
                ...headers,
                'Content-Type': 'application/json',
            },
        }).pipe(map((r) => r.response));
    };
}

export function postJSON(url, body?, options = {}) {
    return baseAjax('POST')(url, body, options);
}

export function putJSON(url, body?, options = {}) {
    return baseAjax('PUT')(url, body, options);
}

export function deleteJSON(url, body = null, options = {}) {
    return baseAjax('DELETE')(url, body, options);
}
